import { render, staticRenderFns } from "./studios.vue?vue&type=template&id=5b2333a8&"
import script from "./studios.vue?vue&type=script&lang=js&"
export * from "./studios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports